(() => {
  const PRODUCT_SCOPE = 'product-info';
  const PDP_WISHLIST_WRAPPER = `${PRODUCT_SCOPE} .addtocart-wishlist .wishlist`;
  const PDP_WISHLIST_BAR = `${PDP_WISHLIST_WRAPPER} .swym-wishlist-button-bar`;
  const PDP_RENDERED_BUTTON = `${PDP_WISHLIST_WRAPPER} .swym-button`;
  const GRID_SCOPE = 'product-recommendations, .related-products';
  const GRID_BUTTON = `${GRID_SCOPE} .swym-button`;
  const REFRESH_DELAYS = [0, 150, 500, 1200];
  let refreshTimer;
  let observer;
  let cachedPdpWishlistMarkup = '';

  const getProductInfo = () => document.querySelector(PRODUCT_SCOPE);
  const getProductId = () => getProductInfo()?.dataset.productId || '';
  const getVariantId = () => getProductInfo()?.querySelector('form[data-type="add-to-cart-form"] [name="id"]')?.value || '';
  const getProductUrl = () => {
    const productPath = getProductInfo()?.dataset.url || window.location.pathname;
    return `${window.location.origin}${productPath}`;
  };

  const hasWishlistElements = () =>
    Boolean(document.querySelector(PDP_WISHLIST_BAR) || document.querySelector(PDP_RENDERED_BUTTON) || document.querySelector(GRID_BUTTON));

  const withSwym = (callback) => {
    if (window._swat) {
      callback(window._swat);
      return;
    }

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(callback);
  };

  const dedupePdpWishlist = () => {
    const wrapper = document.querySelector(PDP_WISHLIST_WRAPPER);
    if (!wrapper) return;

    const renderedItems = Array.from(wrapper.children).filter((item) =>
      item.matches('.swym-btn-container, .swym-button')
    );
    renderedItems.slice(1).forEach((item) => item.remove());
  };

  const updatePdpWishlistData = (resetState = false) => {
    const productId = getProductId();
    const variantId = getVariantId();
    if (!productId || !variantId) return;

    document.querySelectorAll(PDP_RENDERED_BUTTON).forEach((button) => {
      button.dataset.productId = productId;
      button.dataset.variantId = variantId;
      button.dataset.productUrl = getProductUrl();
      button.dataset.swaction = button.dataset.swaction || 'addToWishlist';
      button.dataset.withEpi = 'true';
      button.className = button.className
        .split(/\s+/)
        .filter(
          (className, index, classNames) =>
            className &&
            classNames.indexOf(className) === index &&
            !/^product_\d+$/.test(className) &&
            !['swym-button', 'swym-add-to-wishlist'].includes(className) &&
            (!resetState || !['swym-added', 'swym-loaded', 'swym-disabled'].includes(className))
        )
        .concat('swym-button', `product_${productId}`)
        .join(' ');
      button.classList.add('swym-add-to-wishlist');
      if (resetState) button.classList.remove('swym-added');
      button.setAttribute('aria-label', 'Add to Wishlist');
      if (resetState) {
        Array.from(button.attributes)
          .filter((attribute) => /^data-swym/i.test(attribute.name))
          .forEach((attribute) => button.removeAttribute(attribute.name));
      }
    });
  };

  const cachePdpWishlistMarkup = () => {
    const wrapper = document.querySelector(PDP_WISHLIST_WRAPPER);
    if (!wrapper?.querySelector('.swym-btn-container, .swym-button')) return;

    cachedPdpWishlistMarkup = wrapper.innerHTML;
  };

  const restorePdpWishlistMarkup = () => {
    const wrapper = document.querySelector(PDP_WISHLIST_WRAPPER);
    if (!wrapper || wrapper.querySelector('.swym-btn-container, .swym-button') || !cachedPdpWishlistMarkup) return;

    wrapper.innerHTML = cachedPdpWishlistMarkup;
    updatePdpWishlistData(true);
  };

  const initializeExistingWishlist = (swat) => {
    restorePdpWishlistMarkup();
    dedupePdpWishlist();
    updatePdpWishlistData(true);

    swat.initializeActionButtons(PRODUCT_SCOPE, '[data-swaction]');
    swat.initializeActionButtons(PRODUCT_SCOPE);
    swat.initializeActionButtons('body');
    if (document.querySelector(GRID_SCOPE)) swat.initializeActionButtons(GRID_SCOPE);

    updatePdpWishlistData();
    cachePdpWishlistMarkup();
    dedupePdpWishlist();
  };

  const refreshWishlist = () => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(() => {
      withSwym((swat) => {
        REFRESH_DELAYS.forEach((delay) => {
          window.setTimeout(() => {
            if (hasWishlistElements()) initializeExistingWishlist(swat);
          }, delay);
        });
      });
    }, 80);
  };

  const observeWishlistChanges = () => {
    if (observer || !document.body) return;

    observer = new MutationObserver((mutations) => {
      if (
        mutations.some((mutation) =>
          Array.from(mutation.addedNodes).some(
            (node) =>
              node.nodeType === Node.ELEMENT_NODE &&
              (node.matches?.(PDP_WISHLIST_WRAPPER) ||
                node.matches?.(PDP_RENDERED_BUTTON) ||
                node.matches?.(GRID_BUTTON) ||
                node.querySelector?.(PDP_WISHLIST_WRAPPER) ||
                node.querySelector?.(PDP_RENDERED_BUTTON) ||
                node.querySelector?.(GRID_BUTTON))
          )
        )
      ) {
        refreshWishlist();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  document.addEventListener('DOMContentLoaded', () => {
    refreshWishlist();
    observeWishlistChanges();
  });

  document.addEventListener('product-info:loaded', refreshWishlist);
  document.addEventListener('product:render', refreshWishlist);
  document.addEventListener('swym:collections-loaded', refreshWishlist);
  document.addEventListener('change', (event) => {
    if (event.target.closest(`${PRODUCT_SCOPE} variant-selects`)) refreshWishlist();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, refreshWishlist);
  }
})();